import dynamic from 'next/dynamic';
import React from 'react';

import { useWindowWidthContext } from '@/contexts/WindowWidthContext';

import AnnouncementCard from './components/AnnouncementCard';
import AnnouncementSkeleton from './components/AnnouncementSkeleton';
import useAnnouncements from './hooks/useAnnouncements';

const CustomCarousel = dynamic(
  () => import('@/components/features/CustomCarousel/CustomCarousel')
);

function AnnouncementCarousel({ activeCommunityId }) {
  const { announcements, loading, setHaveSeenAnnouncement } =
    useAnnouncements(activeCommunityId);
  const { isGtEqMd } = useWindowWidthContext();

  const filteredAnnouncements = announcements?.filter(
    (announcement) => announcement?.title
  );
  // Only render customCarousel is needed, else just render AnnouncementCard
  const renderAnnouncementCards = () => {
    if (!filteredAnnouncements?.length) {
      return;
    }

    if (filteredAnnouncements?.length > 1) {
      return (
        <CustomCarousel
          plugins={{ autoplay: true }}
          showArrowButtons={isGtEqMd}>
          {filteredAnnouncements.map((announcement, index) => (
            <div
              key={index}
              className="relative mb-20 flex flex-shrink-0 flex-grow-0 basis-11/12 pr-16 md:basis-full md:px-20">
              <AnnouncementCard
                announcement={announcement}
                setHaveSeenAnnouncement={setHaveSeenAnnouncement}
              />
            </div>
          ))}
        </CustomCarousel>
      );
    }
    return (
      <div className="relative mb-20 flex flex-shrink-0 flex-grow-0 basis-full px-20">
        <AnnouncementCard
          announcement={filteredAnnouncements[0]}
          setHaveSeenAnnouncement={setHaveSeenAnnouncement}
        />
      </div>
    );
  };

  return (
    <div className="c-HomeTab-Carousel mt-24">
      {loading ? <AnnouncementSkeleton /> : renderAnnouncementCards()}
    </div>
  );
}

export default AnnouncementCarousel;
